import { render, staticRenderFns } from "./ShowingShowScreen.vue?vue&type=template&id=345b70fd&"
import script from "./ShowingShowScreen.vue?vue&type=script&lang=js&"
export * from "./ShowingShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports